export default {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
};
